
import { LoginDeviceScreenNavigationProps } from "./types"
import React from "react"
import LoginDevice from "./login-device-screen"
import { PageRoot } from "~screens/page-root"


// 登录设备
const LoginDeviceScreen: React.FC<LoginDeviceScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <LoginDevice route={route}/>
    </PageRoot>
  )
}

export default LoginDeviceScreen
